import React from 'react';

const Header: React.FC = () => {
    return (
        <div className="bg-white rounded-xl shadow-sm border p-6 text-center">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">سازنده فایل پیکربندی JSON</h1>
            <small className="text-gray-300 text-sm">(Netbee-TV)</small>
            <p className="text-gray-600 text-sm">ابزار ساده برای ساخت و ویرایش فایل‌های پیکربندی</p>
        </div>
    );
};

export default Header; 